export const iconFontAwesomeArrowsArrowRotateLeft = (
	<i className="fa-solid fa-arrow-rotate-left"></i>
);
